import { withInstall } from '../helpers';

import CollapseItem from './src/QCollapseItem.vue';

export const QCollapseItem = withInstall(CollapseItem);

export type { QCollapseItemProps, QCollapseItemInstance } from './src/types';
